import { render, staticRenderFns } from "./reisen-overview.vue?vue&type=template&id=476b9db3&scoped=true"
import script from "./reisen-overview.vue?vue&type=script&lang=js"
export * from "./reisen-overview.vue?vue&type=script&lang=js"
import style0 from "./reisen-overview.vue?vue&type=style&index=0&id=476b9db3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b9db3",
  null
  
)

export default component.exports